export const ProfileAccountTypes = {
  CREDIT_CARD: 'CREDIT_CARD',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
}

export enum BankAccountTypeEnum {
  CHECKING = 'checking',
  SAVINGS = 'savings',
  BUSINESSCHECKING = 'businessChecking',
}

export interface ProfileForm {
  email: string
  firstName: string
  lastName: string
  phoneNumber: string
  customerProfileId: number
  customerPaymentProfileId: number
  address: string
  city: string
  state: string
  zip: string
  cardNumber: string
  expirationDate: string
  cardCode: string
  routingNumber?: string
  accountNumber?: string
  accountNumberConfirm?: string
  accountType?: BankAccountTypeEnum
  nameOnAccount?: string
}

export interface Profile extends Omit<ProfileForm, 'cardCode'> {
  fullName: string
  cardType: string
  customerAddressId: number
  subscriptionIds: string[]
  routingNumber?: string
  accountNumber?: string
  nameOnAccount?: string
  accountType?: BankAccountTypeEnum
}

export interface Transaction {
  transId: number
  transactionStatus: string
  settleAmount: number
  submitTimeLocal: string
  accountNumber: number
  accountType: string
}

export interface ProfileBillTo {
  email: string
  firstName: string
  lastName: string
  phoneNumber: string
  address: string
  city: string
  state: string
  zip: string
}

export interface SubscriptionPaymentProfile {
  customerType: string
  customerPaymentProfileId: string
  billTo: SubscriptionBillTo
  payment: SubscriptionPayment
}

export interface SubscriptionBillTo {
  zip: string
  firstName: string
  lastName: string
  country: string
  address: string
  city: string
  state: string
}

export interface SubscriptionProfile {
  customerProfileId: string
  paymentProfile: SubscriptionPaymentProfile
  shippingProfile: SubscriptionShippingProfile
  email: string
}

export interface SubscriptionPaymentSchedule {
  totalOccurrences: number
  trialOccurrences: number
  interval: SubscriptionInterval
  startDate: string
}

export interface SubscriptionInterval {
  unit: string
  length: number
}

export interface SubscriptionCreditCard {
  cardNumber: string
  expirationDate: string
}

export interface SubscriptionAchDebit {
  routingNumber: string
  accountNumber: string
  nameOnAccount: string
  accountType: BankAccountTypeEnum
}

export interface SubscriptionPayment {
  creditCard: SubscriptionCreditCard
  achDebit: SubscriptionAchDebit
}

export interface SubscriptionShippingProfile {
  zip: string
  firstName: string
  lastName: string
  country: string
  customerAddressId: string
  address: string
  phoneNumber: string
  city: string
  state: string
}

export interface SubscriptionOrder {
  taxIsAfterDiscount: boolean
  invoiceNumber: string
  description: string
  discountAmount: number
}

export interface Subscription {
  amount: number
  trialAmount: number
  createdAt?: string
  createdDate?: string
  createDate?: string
  createTimeStamp?: string
  dateCreated?: string
  profile: SubscriptionProfile
  name: string
  paymentSchedule: SubscriptionPaymentSchedule
  subscriptionId: string
  startDate: string
  status: string
  order: SubscriptionOrder
}

export const ProfileFormValues: ProfileForm = {
  address: '',
  city: '',
  email: '',
  firstName: '',
  customerProfileId: 0,
  customerPaymentProfileId: 0,
  lastName: '',
  phoneNumber: '',
  state: 'undefined',
  zip: '',
  cardNumber: '',
  expirationDate: '',
  cardCode: '',
  routingNumber: '',
  accountNumber: '',
  accountNumberConfirm: '',
  nameOnAccount: '',
  accountType: BankAccountTypeEnum.CHECKING,
}

export const ProfileValues: Profile = {
  address: '',
  city: '',
  email: '',
  firstName: '',
  customerProfileId: 0,
  customerPaymentProfileId: 0,
  lastName: '',
  phoneNumber: '',
  state: 'undefined',
  zip: '',
  cardNumber: '',
  expirationDate: '',
  fullName: '',
  cardType: '',
  routingNumber: '',
  accountNumber: '',
  nameOnAccount: '',
  accountType: BankAccountTypeEnum.CHECKING,
  customerAddressId: 0,
  subscriptionIds: [],
}
